import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ExtractionCellController::validateCell
* @see Http/Controllers/ExtractionCellController.php:87
* @route '/extraction/grids/{grid}/cells/validate'
*/
export const validateCell = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateCell.url(args, options),
    method: 'post',
})

validateCell.definition = {
    methods: ["post"],
    url: '/extraction/grids/{grid}/cells/validate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ExtractionCellController::validateCell
* @see Http/Controllers/ExtractionCellController.php:87
* @route '/extraction/grids/{grid}/cells/validate'
*/
validateCell.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return validateCell.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionCellController::validateCell
* @see Http/Controllers/ExtractionCellController.php:87
* @route '/extraction/grids/{grid}/cells/validate'
*/
validateCell.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateCell.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::validateCell
* @see Http/Controllers/ExtractionCellController.php:87
* @route '/extraction/grids/{grid}/cells/validate'
*/
const validateCellForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: validateCell.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::validateCell
* @see Http/Controllers/ExtractionCellController.php:87
* @route '/extraction/grids/{grid}/cells/validate'
*/
validateCellForm.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: validateCell.url(args, options),
    method: 'post',
})

validateCell.form = validateCellForm

/**
* @see \App\Http\Controllers\ExtractionCellController::rejectCell
* @see Http/Controllers/ExtractionCellController.php:109
* @route '/extraction/grids/{grid}/cells/reject'
*/
export const rejectCell = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: rejectCell.url(args, options),
    method: 'post',
})

rejectCell.definition = {
    methods: ["post"],
    url: '/extraction/grids/{grid}/cells/reject',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ExtractionCellController::rejectCell
* @see Http/Controllers/ExtractionCellController.php:109
* @route '/extraction/grids/{grid}/cells/reject'
*/
rejectCell.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return rejectCell.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionCellController::rejectCell
* @see Http/Controllers/ExtractionCellController.php:109
* @route '/extraction/grids/{grid}/cells/reject'
*/
rejectCell.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: rejectCell.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::rejectCell
* @see Http/Controllers/ExtractionCellController.php:109
* @route '/extraction/grids/{grid}/cells/reject'
*/
const rejectCellForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: rejectCell.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::rejectCell
* @see Http/Controllers/ExtractionCellController.php:109
* @route '/extraction/grids/{grid}/cells/reject'
*/
rejectCellForm.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: rejectCell.url(args, options),
    method: 'post',
})

rejectCell.form = rejectCellForm

/**
* @see \App\Http\Controllers\ExtractionCellController::batch
* @see Http/Controllers/ExtractionCellController.php:22
* @route '/extraction/grids/{grid}/cells/batch'
*/
export const batch = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batch.url(args, options),
    method: 'post',
})

batch.definition = {
    methods: ["post"],
    url: '/extraction/grids/{grid}/cells/batch',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ExtractionCellController::batch
* @see Http/Controllers/ExtractionCellController.php:22
* @route '/extraction/grids/{grid}/cells/batch'
*/
batch.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return batch.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionCellController::batch
* @see Http/Controllers/ExtractionCellController.php:22
* @route '/extraction/grids/{grid}/cells/batch'
*/
batch.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batch.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::batch
* @see Http/Controllers/ExtractionCellController.php:22
* @route '/extraction/grids/{grid}/cells/batch'
*/
const batchForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: batch.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::batch
* @see Http/Controllers/ExtractionCellController.php:22
* @route '/extraction/grids/{grid}/cells/batch'
*/
batchForm.post = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: batch.url(args, options),
    method: 'post',
})

batch.form = batchForm

/**
* @see \App\Http\Controllers\ExtractionCellController::update
* @see Http/Controllers/ExtractionCellController.php:61
* @route '/extraction/grids/{grid}/cells'
*/
export const update = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/extraction/grids/{grid}/cells',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ExtractionCellController::update
* @see Http/Controllers/ExtractionCellController.php:61
* @route '/extraction/grids/{grid}/cells'
*/
update.url = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grid: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grid: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grid: typeof args.grid === 'object'
        ? args.grid.id
        : args.grid,
    }

    return update.definition.url
            .replace('{grid}', parsedArgs.grid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExtractionCellController::update
* @see Http/Controllers/ExtractionCellController.php:61
* @route '/extraction/grids/{grid}/cells'
*/
update.put = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::update
* @see Http/Controllers/ExtractionCellController.php:61
* @route '/extraction/grids/{grid}/cells'
*/
const updateForm = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ExtractionCellController::update
* @see Http/Controllers/ExtractionCellController.php:61
* @route '/extraction/grids/{grid}/cells'
*/
updateForm.put = (args: { grid: string | number | { id: string | number } } | [grid: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const ExtractionCellController = { validateCell, rejectCell, batch, update }

export default ExtractionCellController